'use client';

import ErrorState from '@/components/ErrorState';
import { useT } from '@/hooks/useT';

export default function CopytradingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useT();
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('error.copytrading.title')}
      description={t('error.copytrading.desc')}
      section="Copytrading"
    />
  );
}
